type FieldType = {
  title: string;
  value: string;
  isNumeric: boolean;
  length: number;
  placeholder: string;
  customValidate?: (val: string) => { error: boolean; message: string };
};

const validateMinMax = (val: string) => {
  const currentVal = Number(val);
  const min = 1;
  const max = 12;
  const error = currentVal < min || currentVal > max;

  return {
    error,
    message: error
      ? `El número no es válido, ingresa un valor entre ${min} y ${max}`
      : ''
  };
};

const companyName: FieldType = {
  title: 'Razón social de la empresa',
  value: '',
  isNumeric: false,
  length: 100,
  placeholder: 'Ingresar nombre'
};
const representative: FieldType = {
  title: 'Nombre del representante',
  value: '',
  isNumeric: false,
  length: 100,
  placeholder: 'Ingresar nombre'
};
const position: FieldType = {
  title: 'Cargo del representante',
  value: '',
  isNumeric: false,
  length: 50,
  placeholder: 'Ingresar cargo'
};

const duration: FieldType = {
  title: 'Duración de prácticas, empleo o internado (meses) ',
  value: '',
  isNumeric: true,
  length: 2,
  placeholder: 'Ingresar cantidad',
  customValidate: validateMinMax
};

const fields = {
  EMPLOYMENT: {
    companyName,
    representative,
    position
  },
  PRACTICES: {
    companyName,
    representative,
    position,
    duration
  },
  CUSTOM: {
    others: ''
  }
};

const allFields: any = {
  charterDesc: 'Tipo de carta',
  companyName: 'Razón social de la empresa',
  representative: 'Nombre del representante legal',
  position: 'Cargo del representante legal',
  duration: 'Duración de prácticas, empleo o internado (meses)',
  others: 'Descripcion otros campos para personalizado'
};

export { fields, allFields };
